import * as React from 'react';
import { observer } from 'mobx-react';

import { useUserStore } from 'stores/index';

import AuthModal from './AuthModal';
import ManagerSegmentModal from './ManagerSegmentModal';
import NewsModal from './NewsModal';
import useNewsFeedEnabled from './hooks/useNewsFeedEnabled';

const ServiceModals: React.FC = () => {
  const userStore = useUserStore();
  const managerId = userStore.user?.id;
  const isNewsFeedEnabled = useNewsFeedEnabled({
    managerId,
    showSegment: userStore.showSegment
  });

  return (
    <>
      <AuthModal />
      <ManagerSegmentModal />
      <NewsModal isFeedEnabled={isNewsFeedEnabled} managerId={managerId} />
    </>
  );
};

export default observer(ServiceModals);
